import { render } from "./LocalTime.vue?vue&type=template&id=65fc3fb3"
import script from "./LocalTime.vue?vue&type=script&lang=js"
export * from "./LocalTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__